import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from 'reportWebVitals'

import Router from 'Router'

import 'skin/index.sass'

const root = ReactDOM.createRoot( document.getElementById( 'root' ) )

root.render( <Router /> )

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
